import Vue from 'vue';
import Vuex from 'vuex';
import Auth from './modules/Auth';
import User from './modules/User';
import Media from './modules/Media';
import Candidates from './modules/Candidates';
import Helpers from './modules/Helpers';
import Loader from './modules/Loader';
import UserFiles from './modules/UserFiles';
import UserFilesCustomLuts from './modules/UserFilesCustomLuts';
import UI from './modules/UI';
import App from './modules/App';
import Files from '@/store/modules/Files';
import Projects from '@/store/modules/Projects';
import Products from '@/store/modules/Products';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: false,
    },
    modules: {
        Auth,
        User,
        File: {
            namespaced: true,
            modules: {
                Media,
                Candidates,
            }
        },
        Helpers,
        Loader,
        UserFiles,
        UserFilesCustomLuts,
        UI,
        App,
        Files,
        Projects,
        Products
    },
    strict: process.env.NODE_ENV !== 'production',
    actions: {
        resetAll: ({ dispatch }) => {
            dispatch('Auth/resetState');
            dispatch('User/resetState');
            dispatch('Loader/resetState');
            dispatch('UI/resetState');
            dispatch('Products/resetState');
            dispatch('App/resetState');
        },
        resetData: ({ dispatch }) => {
            dispatch('User/resetState');
            dispatch('UserFiles/resetState');
            dispatch('Loader/resetState');
            dispatch('UI/resetState');
            dispatch('Products/resetState');
            dispatch('App/resetState');
        },
        resetApp: ({ dispatch }) => {
            dispatch('UserFiles/resetState');
            dispatch('Loader/resetState');
            dispatch('UI/resetState');
            dispatch('Products/resetState');
            dispatch('App/resetState');
        },
    }
});
